module.exports = __webpack_public_path__ + "img/success_illustration.383b19ff.svg";